// extracted by mini-css-extract-plugin
export default {"conditionButton":"comparison-tool_conditionButton__XEDrt","heading":"comparison-tool_heading__DmAGc","caption":"comparison-tool_caption__qVmit"};